import React from 'react';

const UserContext = React.createContext({});

const userInfo = {
  "name": "Charlie",
  "uid": "uid1",
  "role": "kids"
}

export class UserContextProvider extends React.Component {
  render () {
    return (
      <UserContext.Provider
        value={userInfo}
      >
        {this.props.children}
      </UserContext.Provider>
    )
  }
}

// create the consumer as higher order component
export const withUserContext = ChildComponent => props => (
  <UserContext.Consumer>
    {
      context => <ChildComponent {...props} global={context}  />
    }
  </UserContext.Consumer>
);